import React from "react";
import styled from "@emotion/styled";

import { Color } from "../../utils/color";

export const NameInput = () => {
  return (
    <SInput>
      <label>
        *お名前
        <input type="text" placeholder="デマンド太郎" />
      </label>
    </SInput>
  );
};

const SInput = styled.div`
  margin-top: 3rem;
  label {
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
    font-weight: 500;
    color: ${Color.dark};
    line-height: 1;
    input {
      margin-top: 1.5rem;
      width: 100%;
      border: none;
      border: 1px solid ${Color.light};
      background-color: ${Color.light};
      border-radius: 8px;
      padding: 1rem 1.5rem;
      font-size: 0.9rem;
      line-height: 1;
      transition: border 0.2s;
      &:focus {
        outline: none;
        border: 1px solid ${Color.primary};
      }
    }
  }
`;
